import React from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { Delegate } from "./delegate";
import { State, getUserDelegates } from "@store";
import { useSelector, useDispatch } from "react-redux";

export const Delegates: React.FC = () => {
  const storeDispatch = useDispatch();
  const [delegates, fetching, error] = useSelector((state: State) => {
    return [
      state.user_delegates,
      state.network.fetching.user_delegates,
      state.network.error.user_delegates,
    ];
  });

  React.useEffect(() => {
    if (!delegates && !fetching && !error) {
      storeDispatch(getUserDelegates());
    }
  }, [delegates, fetching, error, storeDispatch]);

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Typography variant="subtitle2">List of Delegates</Typography>
      </Grid>
      <Grid item xs={12}>
        <Box mb={2} border={1} borderColor="grey.500" minHeight="224px">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Delegate</TableCell>
                <TableCell style={{ width: "210px" }}>State</TableCell>
                <TableCell style={{ width: "70px", textAlign: "center" }}>
                  Edit
                </TableCell>
                <TableCell style={{ width: "70px", textAlign: "center" }}>
                  Delete
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {delegates && delegates.length ? (
                delegates.map((delegate) => (
                  <Delegate key={delegate.id} delegate={delegate} />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      minHeight="174px"
                      color="text.disabled"
                    >
                      {fetching ? (
                        <CircularProgress size={22} />
                      ) : (
                        "No information added"
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </Grid>
    </React.Fragment>
  );
};
